import {ClickEvent} from "../../../../../infrastructure/models/analytics/click-event";
import {FOOTER_MODULE} from "../footer-module.consts";

export class FooterModuleStoreClickEvent extends ClickEvent {
  section: FOOTER_MODULE.ANALYTICS.STORES_NAMES;

  constructor(params: FooterModuleStoreClickEvent) {
    super('', 'click', 'store');

    this.section = params.section;
  }

  get properties() {
    const properties = super.properties;

    properties.section = this.section;

    return properties;
  }
}
